import SendAppeal from '../pages/SendAppeal.vue'
import CheckAppeal from '../pages/CheckAppeal.vue'
import MainPage from '../pages/MainPage.vue'
import AuthPage from '../pages/AuthPage.vue'
import AppealTable from '../pages/AppealTable.vue'
import EsiaLogin from '../pages/EsiaLogin.vue'
import EsiaRedirect from '../pages/EsiaRedirect.vue'
import AppealReg from '../pages/AppealReg.vue'
import MyAppeals from '../pages/MyAppeals.vue'
import ConsiderationProcedure from '../pages/ConsiderationProcedure.vue'
import PageNotFound from '../pages/PageNotFound.vue'
import PersonalAccount from '../pages/PersonalAccount.vue'
import OrganizationsAppeals from '../pages/OrganizationsAppeals.vue'
import AppealsRegister from '../pages/AppealsRegister.vue'
import DirectoryList from '@/pages/DirectoryList.vue'
import Directory from '../pages/DirectoryPage.vue'
/*
import OtherServices from '../pages/OtherServices.vue'
import RegistrationRegistrars from '../pages/RegistrationRegistrars.vue'
import RegistrarList from '../pages/RegistrarList.vue'*/
import PublicHearingIndex from '../pages/PublicHearingIndex.vue'
import PublicHearingShow from '../pages/PublicHearingShow.vue'
import EnteredTable from '@/pages/EnteredTable'
import UsersTable from '@/pages/UsersTable'

import { getUserRole } from '@/auth'

const role = getUserRole();
const permissions = {
	admin: true,
	registrar: [		
		{ path: '/' },
		{ path: '/authorize' },
		{ path: '/send' },
		{ path: '/esia-choice' },
		{ path: '/esia-login' },
		{ path: '/esia-redirect' },
		{ path: '/procedure' },
		{ path: '/account' },
		{ path: '/check' },
		{ path: '/public-hearing' },
		{ path: '/public-hearing/:id' },
		// { path: '/my-appeals' },
		// { path: '/organizations-appeals' },
		// { path: '/appeal-reg' },
		// { path: '/table' },
	],
	user: [
		{ path: '/' },
		{ path: '/authorize' },
		{ path: '/send' },
		{ path: '/esia-choice' },
		{ path: '/esia-login' },
		{ path: '/esia-redirect' },
		{ path: '/procedure' },
		{ path: '/account' },
		{ path: '/check' },
		{ path: '/public-hearing' },
		{ path: '/public-hearing/:id' },
	],
	guest: [
		{ path: '/' },
		{ path: '/authorize' },
		{ path: '/send' },
		{ path: '/esia-choice' },
		{ path: '/esia-login' },
		{ path: '/esia-redirect' },
		{ path: '/procedure' },
		{ path: '/check' },
		{ path: '/public-hearing' },
		{ path: '/public-hearing/:id' },
	],
}

const permission = permissions[role]

const routes = [
	{
		path: '/',
		component: MainPage,
		name: 'Главная',
		print: false,
		allAccessible: true
	},
	{
		path: '/authorize',
		component: AuthPage,
		name: 'Вход',
		print: false,
		allAccessible: true
	},
	{
		path: '/esia-login',
		component: EsiaLogin,
		name: 'Вход через портал Госуслуги',
		print: false
	},
	{
		path: '/esia-redirect',
		component: EsiaRedirect,
		print: false
	},
	{
		path: '/send',
		component: SendAppeal,
		name: 'Отправить обращение',
	},
	{
		path: '/procedure',
		component: ConsiderationProcedure,
		name: 'Порядок рассмотрения обращений',
	},
	// {
	// 	path: '/registration-account',
	// 	component: RegistrationAccount,
	// 	name: 'Регистрация личного кабинета',
	// },
	{
		path: '/check',
		component: CheckAppeal,
		name: 'Посмотреть состояние обращения'
	},
	{
		path: '/account',
		component: PersonalAccount,
		name: 'Личный кабинет'
	},
	{
		path: '/table',
		component: AppealTable,
		name: 'Кабинет регистратора'
	},
	{
		path: '/appeal-reg',
		component: AppealReg,
		name: 'Формирование обращения'
	},
	{
		path: '/my-appeals',
		component: MyAppeals,
		name: 'Мои обращения'
	},
	{
		path: '/organizations-appeals',
		component: OrganizationsAppeals,
		name: 'Обращения организации'
	},
	{
		path: '/register-appeals',
		component: AppealsRegister,
		name: 'Реестр обращений'
	},
	/*
		{
			path: '/services',
			component: OtherServices,
			name: 'Сервисы'
		},		
		{
			path: '/registration-registrars',
			component: RegistrationRegistrars,
			name: 'Регистрация регистраторов'
		},
		{
			path: '/registrar-list',
			component: RegistrarList,
			name: 'Список регистраторов'
		},*/
	{
		path: '/directories',
		component: DirectoryList,
		name: 'Справочники',
	},
	{
		path: '/directories/:name',
		component: Directory,
		name: 'Справочник',
		print: false,
	},
	{
		path: '/public-hearing',
		component: PublicHearingIndex,
		name: 'Предложения к публичному слушанию',
	},
	{
		path: '/public-hearing/:id',
		component: PublicHearingShow,
		// name: 'Предложения к публичному слушанию',
		print: false,
	},	
	{
		path: '/entered-table',
		component: EnteredTable,
		name: 'Журнал входов регистраторов',
	},
	{
		path: '/users',
		component: UsersTable,
		name: 'Список пользователей',
	},
	{
		path: '/404',
		component: PageNotFound,
		print: false,
		allAccessible: true,
	},
	{
		path: '/:pathMatch(.*)*',
		component: PageNotFound,
		print: false,
		allAccessible: true,
		beforeEnter() { window.location.href = "/404" },
	},
]

export default routes
	.filter(route => permission === true || route.allAccessible || permission.find(perm => perm.path === route.path))
	.map(route => {
		if (permission === true) return route

		let perm = permission.find(perm => perm.path === route.path)
		if (perm && route.print !== false) route.print = perm.print !== false

		return route
	})